module.exports = __webpack_public_path__ + "img/CPS.3af690bc.png";